export const ICreationStepAutoBook = Object.freeze({
  active: "active",
});

export class CreationStepAutoBookModel {
  constructor(data = {}) {
    this[ICreationStepAutoBook.active] = data[ICreationStepAutoBook.active];
  }

  isAutoBookActivated() {
    return this[ICreationStepAutoBook.active] === true;
  }
}
